<ng-container>
  <div class="fund-document-card">
    <eds-panel edsSpacing="md" [hasBorders]="true" theme="white">
      <div edsFlexbox edsPadding edsPaddingLeft="md" edsPaddingTop="md">
        <ng-container *ngFor="let data of finalRow">
          <ng-container *ngIf="data.colId === 'MULTI_SELECT_CHECKBOX'">
            <eds-checkbox
              [id]="rowData.literatureData?.rowId"
              name="story-checkbox"
              [value]="rowData.literatureData?.rowId"
              [disabled]="false"
              [checked]="this.rowData.literatureData.isSelected"
              [hideLabel]="false"
              [required]="false"
              (checkedChange)="onSelectionChanged($event, rowData)"
            >
            </eds-checkbox>
          </ng-container>
        </ng-container>

        <div class="fund-document-card__pdf-column">
          <ng-container *ngFor="let data of finalRow">
            <ng-container
              *ngIf="data.colId === 'NAME' || data.colId === 'TITLE'"
            >
              <div edsFlexbox flexDirection="column">
                <div
                  class="text-grey1"
                  [ngClass]="
                    (isMobile$ | async)
                      ? 'fund-document-card__pdf-column--is-mobile'
                      : ''
                  "
                >
                  {{ "literature.pdf-format" | translate }}
                </div>
                <ft-fund-name-cell-renderer
                  [cellRendererData]="rendererData"
                ></ft-fund-name-cell-renderer>
              </div>
            </ng-container>

            <ng-container *ngIf="data.colId === 'DETAIL'">
              <eds-panel edsSpacing="md" theme="grey" [hasPadding]="true">
                <ft-document-detail
                  [cellRendererData]="rendererData"
                  [convertDateTo]="convertDateTo"
                ></ft-document-detail>
              </eds-panel>
            </ng-container>
            <ng-container
              *ngIf="
                data.colId === 'PUBLICATION_DATE' &&
                (isIntel || !rowData.literatureData?.clientUse)
              "
            >
              <eds-panel edsSpacing="md" theme="grey" [hasPadding]="true">
                <div edsGrid>
                  <div edsRow>
                    <div edsCol [columnNumbers]="{ s: 2, m: 2 }">
                      {{ data.label }}:
                    </div>
                    <div
                      *ngIf="data.val"
                      edsCol
                      [columnNumbers]="{ s: 2, m: 2 }"
                    >
                      {{ data.val }}
                    </div>
                  </div>
                </div>
              </eds-panel>
            </ng-container>
            <ng-container *ngIf="data.colId === 'ACTION'">
              <div
                edsFlexbox
                edsSpacing="md"
                edsPadding
                [edsPaddingTop]="(isMobile$ | async) ? 'md' : ''"
              >
                <ft-document-download [cellRendererData]="rendererData">
                </ft-document-download>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </eds-panel>
  </div>
</ng-container>
